import controller from '../vd-badge.controller'
import template from './vd-customer-badge.html'

const CustomerBadgeComponent = {
  bindings: {
    current: '<?',
    customer: '<',
    group: '<?',
    highlight: '<?',
    hyperlink: '@?',
    interactive: '@?',
    size: '@?',
  },
  controller,
  template,
}

export default CustomerBadgeComponent
